export default "__VITE_ASSET__BbdRiDnl__"